export const subscriptionEndpoints = (builder) => ({
    createSubscription: builder.mutation({
        query: (data) => ({ url: `/subscriptions`, method: 'post', body: data }),
        invalidatesTags: ['Subscriptions'],
    }),
    updateSubscription: builder.mutation({
        query: ({ subId, ...data }) => ({ url: `/subscriptions/${subId}`, method: 'patch', body: data }),
        invalidatesTags: ['Subscriptions'],
    }),
    renewSubscription: builder.mutation({
        query: ({ userId, subId, meta }) => ({ url: `/subscriptions/${subId}`, method: 'post', body: { userId, meta } }),
        invalidatesTags: ['Subscriptions'],
    }),
    cancelSubscription: builder.mutation({
        query: ({ userId, subId, meta }) => ({ url: `/subscriptions/${subId}`, method: 'delete', body: { userId, meta } }),
        invalidatesTags: ['Subscriptions'],
    }),
    downloadSubscriptionReport: builder.mutation({
        query: ({ userId, userGroup, status, type, format }) => ({
            url: `/subscriptions/report/${format}?userGroup=${userGroup || ""}`
                + `&userId=${userId || ""}`
                + `&type=${type || ""}`
                + `&status=${status || ""}`,
            method: 'post'
        }),
    }),
    downloadBillingReport: builder.mutation({
        query: ({ userId, userGroup, status, type, format }) => ({
            url: `/subscriptions/billing/report/${format}?userGroup=${userGroup || ""}`
                + `&userId=${userId || ""}`
                + `&type=${type || ""}`
                + `&status=${status || ""}`,
            method: 'post'
        }),
    }),
})